import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
    name: 'currencyAmount',
    pure: true,
    standalone: true
})
@Injectable({
  providedIn: 'root'
})
export class CurrencyAmountPipe implements PipeTransform {

  transform(
    value: number | string | null | undefined,
    symbol: string = '$'
  ): string {
    const safeSymbol = symbol && symbol.trim() && symbol !== '-' ? symbol : '$';

    // null / undefined / empty
    if (value === null || value === undefined || value === '') {
      return '-';
    }

    const num =
      typeof value === 'string'
        ? Number(value.split(' ')[0])
        : Number(value);

    // NaN or zero
    if (isNaN(num) || num === 0) {
      return '-';
    }

    const hasDecimals = num % 1 !== 0;

    const formatted = num.toLocaleString('en-US', {
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: 2
    });

    return `${safeSymbol}${formatted}`;
  }
}
